export default {
  CREATE_MEDITATION(state, payload) {},
  GET_MEDITATION(state, payload) {
    state.meditation = payload;
  },
  EDIT_MEDITATION(state, payload) {},
  DELETE_MEDITATION(state, payload) {},
};
